import { DefaultMoniepointAppParameters, MoniepointAppParameters } from '../../core/models/login.model';
import { StringHelper } from '../../core/helpers/strings.helper';
import {StorageKeys} from "./storage-keys";

export function isMoniepointAppUser() {
	const userAgent = window.navigator.userAgent.toLowerCase();
	return /moniepointmobile/.test(userAgent);
}

export function getMobileAppVersion() {
	return localStorage.getItem('mobile_App_Version') || null;
}

function getWindowsClient() {
	// @ts-ignore
	return new ClientJS();
}

function getConfig() {
	let config = null;
	try {
		// tslint:disable-next-line:no-string-literal
		config = window['inject']['CONFIG'];
	} catch (err) {
	}
	return config;
}

function getDeviceUniqueIdentifier() {
	const config = getConfig();
	const USE_UUID_FOR_DEVICE_ID = config ? config?.USE_UUID_FOR_DEVICE_ID : false;
	if(USE_UUID_FOR_DEVICE_ID){
		return StringHelper.getUUID();
	}
	const client = getWindowsClient();
	return client.getFingerprint().toString();
}

function getMachineOS() {
	const client = getWindowsClient();
	return client.getOS();
}

function getBrowser() {
	const client = getWindowsClient();
	return client.getBrowser();
}

function webAppParameters(mobileAppParameters: MoniepointAppParameters) {
	const deviceRegistrationRequest = mobileAppParameters.deviceRegistrationRequest;
	deviceRegistrationRequest.model = 'WEB';
	deviceRegistrationRequest.deviceUniqueIdentifier = getDeviceUniqueIdentifier();
	deviceRegistrationRequest.manufacturer = getMachineOS();
	mobileAppParameters.deviceRegistrationRequest = deviceRegistrationRequest;
	return mobileAppParameters;
}

function getUpdatedAppParameters(params) {
	if (!params.hasNoDeviceId) {
		return params.mobileAppParameters;
	}
	const newDeviceId = getDeviceUniqueIdentifier();
	params.mobileAppParameters.deviceRegistrationRequest.deviceUniqueIdentifier = newDeviceId;
	params.mobileAppParameters.isWebUniqueIdentifier = true;
	return params.mobileAppParameters;
}

function mobileAppParam(userAgent, mobileAppParameters) {
	const startPoint = userAgent?.indexOf('mp-1:') + 5;
	const endPoint = userAgent?.indexOf(':mp-2');
	const parameters = userAgent?.substring(startPoint, endPoint);
	try {
		mobileAppParameters = JSON.parse(parameters);
		const hasNoDeviceId = StringHelper.isNullOrEmptyOrUndefined(mobileAppParameters?.deviceRegistrationRequest?.deviceUniqueIdentifier);
		const params = { hasNoDeviceId, mobileAppParameters };
		mobileAppParameters = getUpdatedAppParameters(params);
	} catch (e) {
		console.log('Error parsing ---->> ', e);
	}
	return mobileAppParameters;
}

export function moniepointAppParameters(): MoniepointAppParameters {
	let mobileAppParameters: MoniepointAppParameters = DefaultMoniepointAppParameters;
	const userAgent = window.navigator.userAgent;
	const hasMobileAppParameters = /mp-1:/.test(userAgent) && /:mp-2/.test(userAgent);
	if (!hasMobileAppParameters) {
		return webAppParameters(mobileAppParameters);
	}
	mobileAppParameters.userAgent = userAgent;
	mobileAppParameters = mobileAppParam(userAgent, mobileAppParameters);
  const deviceRegistrationRequest = mobileAppParameters?.deviceRegistrationRequest;
  localStorage.setItem(StorageKeys.unique_device_identifier, `${deviceRegistrationRequest?.deviceUniqueIdentifier}`);
  localStorage.setItem(StorageKeys.encrypted_unique_device_identifier, `${deviceRegistrationRequest?.deviceUniqueIdentifier}`);
	localStorage.setItem('mobile_App_Version', mobileAppParameters?.appVersion);
	return mobileAppParameters;
}
